import AuthCode from '@/components/ecommerce/AuthCode';
import ProductBadge from '@/components/ecommerce/product/ProductBadge';
import If from '@/components/util/IF';
import useItemContext from '@/hooks/useItemContext';
import clsx from 'clsx';
import React from 'react';

type Props = {

    isEverythingLoaded: boolean;
};

const ProductEcomCodeAndBadge = ({ isEverythingLoaded }: Props) => {
    const { item } = useItemContext();
    return (
        <div className={clsx('flex flex-row space-x-3 md:justify-start justify-center mb-6')}>
            <AuthCode trId={item?.tr_id || ''} type={item?.authentication_type} isLoading={!isEverythingLoaded} id="bid-top" itemType={item?.type} />
            <If condition={item && item.trending}>
                <ProductBadge theme="purple" type="trending" />
            </If>
        </div>
    );
};

export default ProductEcomCodeAndBadge;
